export const faqData = [
  {
    question: '51cg吃瓜是什么平台？',
    answer: '51cg吃瓜是一个专注于网红八卦、明星争议与热门人物黑料的资讯聚合平台。我们每日更新最新吃瓜内容，涵盖51吃瓜台北娜娜、莫里秀、玩偶姐姐等热门人物动态，为吃瓜群众提供第一手深度爆料与事件梳理。'
  },
  {
    question: '51吃瓜台北娜娜是谁？为什么这么火？',
    answer: '台北娜娜是近期社交平台最具话题度的网红之一，因多起争议事件引发广泛讨论。51cg吃瓜持续追踪其动态，从早期账号运营到近期风波，提供完整时间线与多方视角解读。'
  },
  {
    question: '如何关注玩偶姐姐的最新动态？',
    answer: '玩偶姐姐作为热门网红，其每一次动态都牵动吃瓜群众神经。51cg吃瓜设有专属专题，实时更新玩偶姐姐的社交动态、争议回应、粉丝反应及圈内评价，不错过任何一个瓜。'
  },
  {
    question: '莫里秀事件的来龙去脉是什么？',
    answer: '51吃瓜莫里秀事件是近期最具影响力的网红争议之一，涉及多方当事人与大量爆料材料。我们在专题页面中整理了事件完整脉络，包括关键时间节点、当事人声明及后续发展追踪。'
  },
  {
    question: '平台内容多久更新一次？',
    answer: '51cg吃瓜保持24小时滚动更新机制，编辑团队全天候监控各大社交平台与爆料渠道。热点事件发生15分钟内即有快讯推送，深度专题文章通常在事件发酵2小时内上线。'
  },
  {
    question: '如何参与吃瓜讨论或投稿爆料？',
    answer: '可通过页面底部的联系我们板块提交爆料线索或投稿。我们重视每一位吃瓜群众的贡献，经核实的爆料将在显著位置发布并标注来源。同时欢迎加入评论区讨论，理性吃瓜。'
  }
];

export const mediaData = [
  {
    title: '台北娜娜争议全程回顾',
    duration: '深度解析',
    views: '128.5万',
    imageSeq: 'media-01',
    imageQuery: 'Dramatic%20dark%20themed%20entertainment%20news%20visual%20with%20abstract%20spotlight%20effect%2C%20warm%20crimson%20and%20charcoal%20tones%2C%20cinematic%20composition%20with%20mysterious%20atmosphere%2C%20editorial%20style%20with%20dramatic%20lighting%20and%20deep%20shadows%2C%20gossip%20media%20aesthetic'
  },
  {
    title: '玩偶姐姐最新回应解读',
    duration: '独家分析',
    views: '96.3万',
    imageSeq: 'media-02',
    imageQuery: 'Dark%20moody%20visual%20with%20abstract%20geometric%20patterns%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20lighting%20with%20soft%20glow%20effects%2C%20entertainment%20news%20broadcast%20aesthetic%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20professional%20editorial%20photography%20style'
  },
  {
    title: '莫里秀风波时间线梳理',
    duration: '事件全貌',
    views: '213.7万',
    imageSeq: 'media-03',
    imageQuery: 'Abstract%20dramatic%20composition%20with%20intersecting%20light%20beams%20in%20warm%20gold%20and%20crimson%20hues%2C%20dark%20background%20with%20textured%20overlay%2C%20cinematic%20mystery%20theme%2C%20editorial%20spotlight%20effect%2C%20professional%20media%20production%20aesthetic'
  }
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    description: '24小时监控全网热点，第一时间推送网红争议与明星爆料，吃瓜快人一步。'
  },
  {
    icon: 'ri-file-search-line',
    title: '深度深扒',
    description: '专业编辑团队多维度调查，还原事件真相，提供完整脉络与多方视角。'
  },
  {
    icon: 'ri-group-line',
    title: '吃瓜社区',
    description: '聚集百万吃瓜群众，理性讨论热点事件，共享最新八卦资讯与内幕消息。'
  },
  {
    icon: 'ri-shield-check-line',
    title: '信息核验',
    description: '多重信源交叉验证，标注信息可信度等级，守护吃瓜群众的信息安全。'
  }
];

export const aboutData = {
  title: '关于51cg吃瓜',
  content: '51cg吃瓜成立于2024年，是国内领先的网红八卦与明星争议资讯聚合平台。我们以"理性吃瓜、深度追踪"为核心理念，专注于51吃瓜台北娜娜、莫里秀、玩偶姐姐等热门人物的动态追踪与事件深扒。平台日均更新内容超50篇，覆盖全网热门吃瓜话题，拥有超过百万活跃吃瓜群众。我们的编辑团队由资深娱乐记者与新媒体运营专家组成，坚持多方信源交叉核验，为读者提供真实、全面、及时的热门人物黑料与争议事件报道。51cg吃瓜不仅是一个资讯平台，更是吃瓜群众交流讨论的社区家园。'
};

export const indexData = [
  { title: '51吃瓜台北娜娜专区', count: '238篇', tag: '热门', imageSeq: 'index-01', imageQuery: 'Dark%20themed%20abstract%20visual%20with%20soft%20crimson%20gradient%20and%20subtle%20spotlight%2C%20editorial%20magazine%20cover%20aesthetic%2C%20warm%20atmospheric%20tones%2C%20mysterious%20and%20elegant%20composition%2C%20professional%20media%20design' },
  { title: '玩偶姐姐完整档案', count: '186篇', tag: '爆款', imageSeq: 'index-02', imageQuery: 'Dramatic%20dark%20composition%20with%20amber%20and%20deep%20red%20light%20streaks%2C%20abstract%20cinematic%20glow%2C%20entertainment%20media%20vibe%2C%20mysterious%20atmosphere%20with%20warm%20undertones%2C%20editorial%20photography%20style' },
  { title: '莫里秀争议全记录', count: '157篇', tag: '追踪', imageSeq: 'index-03', imageQuery: 'Warm%20dark%20abstract%20visual%20with%20golden%20light%20rays%20and%20crimson%20accents%2C%20dramatic%20theatrical%20lighting%2C%20mysterious%20editorial%20composition%2C%20professional%20media%20aesthetic%20with%20deep%20shadows' },
  { title: '网红黑料档案库', count: '312篇', tag: '独家', imageSeq: 'index-04', imageQuery: 'Dark%20atmospheric%20visual%20with%20layered%20crimson%20and%20charcoal%20abstract%20patterns%2C%20dramatic%20spotlight%20effect%2C%20investigative%20journalism%20aesthetic%2C%20mysterious%20and%20compelling%20composition%2C%20editorial%20design' },
  { title: '明星争议大起底', count: '275篇', tag: '深度', imageSeq: 'index-05', imageQuery: 'Abstract%20dramatic%20composition%20with%20warm%20golden%20and%20burgundy%20tonal%20gradients%2C%20cinematic%20lighting%20with%20soft%20glow%2C%20entertainment%20news%20atmosphere%2C%20mysterious%20editorial%20style%20with%20deep%20contrast' },
  { title: '吃瓜大赛精选集', count: '198篇', tag: '热推', imageSeq: 'index-06', imageQuery: 'Dynamic%20dark%20visual%20with%20intersecting%20warm%20light%20beams%20in%20amber%20and%20red%20tones%2C%20dramatic%20cinematic%20composition%2C%20competition%20event%20aesthetic%2C%20mysterious%20atmosphere%2C%20editorial%20design' },
  { title: '网红塌房全记录', count: '143篇', tag: '震撼', imageSeq: 'index-07', imageQuery: 'Intense%20dark%20themed%20visual%20with%20dramatic%20crimson%20light%20burst%20and%20deep%20shadows%2C%20breaking%20news%20aesthetic%2C%20mysterious%20and%20powerful%20composition%2C%20editorial%20media%20design%20with%20high%20contrast' },
  { title: '社交平台热帖汇', count: '421篇', tag: '实时', imageSeq: 'index-08', imageQuery: 'Abstract%20dark%20composition%20with%20warm%20golden%20and%20crimson%20gradient%20overlay%2C%20social%20media%20feed%20aesthetic%2C%20dramatic%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20design%20style' },
  { title: '争议人物专题页', count: '167篇', tag: '关注', imageSeq: 'index-09', imageQuery: 'Dark%20atmospheric%20visual%20with%20soft%20amber%20spotlight%20and%20deep%20burgundy%20background%2C%20portrait%20documentary%20aesthetic%2C%20mysterious%20and%20compelling%20composition%2C%20editorial%20magazine%20style' }
];

export const appData = {
  title: '随时随地 · 掌上吃瓜',
  description: '51cg吃瓜移动端适配完美，支持手机浏览器直接访问。收藏本站即可在手机主屏幕一键打开，吃瓜不延迟，热点不错过。所有功能与桌面端同步，深夜吃瓜更尽兴。',
  features: ['无延时推送通知', '完美适配手机屏幕', '离线缓存阅读', '深色模式护眼']
};

export const rankingData = [
  { rank: 1, title: '台北娜娜最新回应：否认所有指控', heat: '🔥 285.6万', tag: '爆' },
  { rank: 2, title: '玩偶姐姐被曝与经纪公司解约', heat: '🔥 198.3万', tag: '新' },
  { rank: 3, title: '莫里秀事件第三方当事人发声', heat: '🔥 176.9万', tag: '热' },
  { rank: 4, title: '51吃瓜大赛年度评选启动', heat: '152.4万', tag: '荐' },
  { rank: 5, title: '某顶流网红疑似人设崩塌', heat: '138.7万', tag: '疑' },
  { rank: 6, title: '社交平台连夜删除相关话题', heat: '121.5万', tag: '追' },
  { rank: 7, title: '吃瓜群众票选年度最震撼事件', heat: '98.2万', tag: '投' }
];

export const cardsData = [
  {
    title: '深扒台北娜娜：从素人到顶流的争议之路',
    excerpt: '从默默无闻到全网热议，台北娜娜的走红之路布满争议。本文梳理其完整发展轨迹，包括早期账号运营、关键转折事件及近期风口浪尖上的种种回应。',
    author: '深度编辑部',
    time: '2小时前',
    imageSeq: 'card-01',
    imageQuery: 'Dark%20dramatic%20editorial%20visual%20with%20crimson%20and%20amber%20abstract%20light%20patterns%2C%20investigative%20journalism%20aesthetic%2C%20mysterious%20spotlight%20composition%2C%20professional%20media%20photography%20style%20with%20warm%20undertones'
  },
  {
    title: '玩偶姐姐商业版图揭秘：背后资本浮出水面',
    excerpt: '玩偶姐姐背后复杂的商业关系网逐渐清晰。从签约公司到自主品牌，从直播带货到跨界合作，一条完整的商业路径被51cg吃瓜完整还原。',
    author: '商业观察组',
    time: '5小时前',
    imageSeq: 'card-02',
    imageQuery: 'Dark%20atmospheric%20composition%20with%20warm%20golden%20and%20burgundy%20abstract%20shapes%2C%20business%20investigation%20aesthetic%2C%20dramatic%20cinematic%20lighting%2C%20mysterious%20editorial%20style%2C%20professional%20media%20design'
  },
  {
    title: '莫里秀事件全解析：时间线、人物关系与争议焦点',
    excerpt: '51吃瓜莫里秀事件牵涉多方利益，本文以时间线形式完整呈现事件始末，梳理核心人物关系图谱，标记关键争议节点与各方立场声明。',
    author: '专题报道组',
    time: '8小时前',
    imageSeq: 'card-03',
    imageQuery: 'Dark%20themed%20visual%20with%20dramatic%20crimson%20light%20streaks%20and%20deep%20shadows%2C%20investigative%20timeline%20aesthetic%2C%20mysterious%20cinematic%20composition%2C%20professional%20editorial%20design%20with%20warm%20tones'
  },
  {
    title: '2025网红塌房年鉴：那些年我们追过的瓜',
    excerpt: '整理年度最具影响力的网红争议事件，从年初到年末，那些震惊全网的塌房瞬间与后续发展追踪，51cg吃瓜为您完整记录。',
    author: '年鉴编辑组',
    time: '12小时前',
    imageSeq: 'card-04',
    imageQuery: 'Dark%20dramatic%20abstract%20visual%20with%20warm%20amber%20and%20deep%20red%20gradient%20layers%2C%20yearbook%20retrospective%20aesthetic%2C%20cinematic%20mysterious%20atmosphere%2C%20editorial%20design%20composition'
  },
  {
    title: '吃瓜群众心理学：为何我们沉迷八卦无法自拔',
    excerpt: '从社会心理学角度分析吃瓜文化盛行背后的深层原因，探讨信息时代公众对网红隐私的窥探欲与道德边界的模糊地带。',
    author: '文化评论组',
    time: '1天前',
    imageSeq: 'card-05',
    imageQuery: 'Dark%20atmospheric%20visual%20with%20soft%20crimson%20and%20charcoal%20abstract%20patterns%2C%20psychological%20analysis%20aesthetic%2C%20mysterious%20editorial%20composition%2C%20professional%20media%20design%20with%20warm%20undertones'
  },
  {
    title: '社交媒体时代的网红经济：流量背后的真相',
    excerpt: '解析当下网红经济的运作模式，从数据造假到流量变现，从粉丝经济到危机公关，51cg吃瓜带你认清网红行业的真实面貌。',
    author: '产业分析组',
    time: '1天前',
    imageSeq: 'card-06',
    imageQuery: 'Dark%20themed%20visual%20with%20warm%20golden%20light%20rays%20and%20burgundy%20abstract%20elements%2C%20economic%20analysis%20aesthetic%2C%20dramatic%20cinematic%20composition%2C%20mysterious%20editorial%20style'
  },
  {
    title: '爆料渠道大揭秘：吃瓜信息从何而来',
    excerpt: '51cg吃瓜的信息来源网络覆盖多个维度，从匿名投稿到公开平台监控，从圈内人士爆料到数据分析挖掘，揭秘我们的信息采集全流程。',
    author: '运营揭秘组',
    time: '2天前',
    imageSeq: 'card-07',
    imageQuery: 'Dark%20mysterious%20visual%20with%20crimson%20and%20amber%20abstract%20light%20patterns%20intersecting%2C%20investigative%20network%20aesthetic%2C%20dramatic%20cinematic%20composition%2C%20professional%20editorial%20design%20with%20deep%20shadows'
  }
];

export const topicsData = [
  { name: '#51吃瓜台北娜娜', heat: '285.6万' },
  { name: '#玩偶姐姐', heat: '198.3万' },
  { name: '#莫里秀事件', heat: '176.9万' },
  { name: '#网红塌房', heat: '152.4万' },
  { name: '#吃瓜大赛', heat: '138.7万' },
  { name: '#明星争议', heat: '121.5万' },
  { name: '#黑料爆料', heat: '108.2万' },
  { name: '#人设崩塌', heat: '95.8万' },
  { name: '#年度吃瓜盘点', heat: '82.3万' }
];

export const contactData = {
  title: '联系我们',
  description: '有猛料想爆料？有线索想提供？有疑问想咨询？51cg吃瓜欢迎每一位吃瓜群众的参与。请通过以下方式联系我们的编辑团队，我们会在24小时内回复。',
  email: 'tips@51cg.com',
  wechat: '51cg_editor',
  qq: '800123456'
};

export const updatesData = [
  { time: '10分钟前', content: '台北娜娜工作室发布最新声明，针对近日网络传闻逐一回应', tag: '实时' },
  { time: '35分钟前', content: '玩偶姐姐社交账号突然清空所有内容，引发粉丝集体猜测', tag: '突发' },
  { time: '1小时前', content: '莫里秀事件涉事品牌方正式发出律师函，要求停止传播不实信息', tag: '追踪' },
  { time: '2小时前', content: '51吃瓜大赛第三轮投票通道开启，当前排名发生剧烈变动', tag: '活动' },
  { time: '3小时前', content: '多位网红被曝私下建群互撕，聊天记录截屏在网络流传', tag: '爆料' },
  { time: '5小时前', content: '吃瓜群众热议：今年最令人意外的塌房事件是哪一桩？', tag: '讨论' },
  { time: '7小时前', content: '某短视频平台下架与争议网红相关的全部内容', tag: '更新' },
  { time: '10小时前', content: '51cg吃瓜独家：匿名爆料人提供关键证据材料，正在核实中', tag: '独家' }
];

export const carouselData = [
  {
    title: '台北娜娜：从爆红到争议的365天',
    subtitle: '年度最受关注网红沉浮录',
    excerpt: '从无名素人到全网焦点，再到争议漩涡中心——台北娜娜的走红轨迹堪称网红时代的标本案例。51cg吃瓜以独家视角完整记录她的每步足迹。',
    imageSeq: 'carousel-01',
    imageQuery: 'Dramatic%20dark%20cinematic%20visual%20with%20intense%20crimson%20spotlight%20and%20deep%20charcoal%20shadows%2C%20celebrity%20documentary%20aesthetic%2C%20mysterious%20portrait%20atmosphere%2C%20professional%20editorial%20photography%20with%20warm%20dramatic%20lighting%2C%20abstract%20composition'
  },
  {
    title: '玩偶姐姐商业帝国探秘',
    subtitle: '揭开网红流量变现的完整链路',
    excerpt: '从直播间到品牌矩阵，玩偶姐姐打造的商业版图远比外界看到的庞大。51cg吃瓜深入调查其背后的资本运作与资源网络。',
    imageSeq: 'carousel-02',
    imageQuery: 'Dark%20atmospheric%20visual%20with%20warm%20golden%20amber%20light%20rays%20and%20burgundy%20abstract%20textures%2C%20business%20empire%20aesthetic%2C%20dramatic%20cinematic%20composition%2C%20mysterious%20luxury%20atmosphere%2C%20editorial%20design%20style'
  },
  {
    title: '莫里秀事件：真相与谎言的对决',
    subtitle: '2025最具争议网红事件全景还原',
    excerpt: '一场始于直播间的争议，最终演变为牵涉多方的舆论风暴。51吃瓜莫里秀事件专题，带你穿透迷雾看清每一个关键节点。',
    imageSeq: 'carousel-03',
    imageQuery: 'Intense%20dark%20themed%20visual%20with%20dramatic%20crimson%20and%20amber%20light%20clash%2C%20confrontation%20aesthetic%2C%20cinematic%20mystery%20atmosphere%2C%20professional%20editorial%20photography%20with%20deep%20contrast%2C%20abstract%20composition'
  },
  {
    title: '网红黑料经济学',
    subtitle: '为什么塌房越多，流量越大',
    excerpt: '揭秘网红黑料背后的流量逻辑与商业利益链。当争议成为流量密码，吃瓜群众在其中的角色究竟是观众还是推手？51cg吃瓜深度剖析。',
    imageSeq: 'carousel-04',
    imageQuery: 'Dark%20abstract%20visual%20with%20warm%20golden%20and%20crimson%20geometric%20patterns%2C%20economic%20analysis%20aesthetic%2C%20dramatic%20cinematic%20lighting%2C%20mysterious%20editorial%20composition%2C%20professional%20media%20design%20with%20data%20visualization%20vibe'
  },
  {
    title: '51吃瓜大赛年度盛典',
    subtitle: '全民票选 · 瓜王争霸',
    excerpt: '一年一度的吃瓜盛事正式启动！从百大候选事件中票选出年度最具影响力的十大瓜王。谁是你心中的年度最佳？投票通道已全面开启。',
    imageSeq: 'carousel-05',
    imageQuery: 'Dark%20festive%20visual%20with%20dramatic%20crimson%20and%20golden%20amber%20spotlights%2C%20award%20ceremony%20aesthetic%2C%20cinematic%20celebration%20atmosphere%2C%20mysterious%20elegant%20composition%2C%20editorial%20design%20with%20warm%20glamorous%20tones'
  },
  {
    title: '吃瓜群众生存指南',
    subtitle: '在信息洪流中理性吃瓜',
    excerpt: '面对海量真伪难辨的网红八卦信息，如何保持理性判断？51cg吃瓜整理了十条甄别法则，帮助每位吃瓜群众在娱乐中保持清醒与独立思考。',
    imageSeq: 'carousel-06',
    imageQuery: 'Dark%20atmospheric%20visual%20with%20soft%20amber%20glow%20and%20crimson%20abstract%20elements%2C%20educational%20guide%20aesthetic%2C%20cinematic%20calm%20mysterious%20composition%2C%20professional%20editorial%20design%20with%20warm%20reassuring%20tones'
  }
];

export const commentsData = [
  {
    avatar: 'R',
    name: '吃瓜一线群众',
    time: '3分钟前',
    content: '台北娜娜这个事情反转太多了，坐等后续发展。51cg的整理真的清晰，终于把时间线理清楚了！',
    likes: 2836
  },
  {
    avatar: 'M',
    name: '理性吃瓜人',
    time: '15分钟前',
    content: '说实话玩偶姐姐的商业头脑确实厉害，但争议也是事实。希望大家理性讨论，不要人身攻击。51cg这篇分析写得很客观。',
    likes: 1921
  },
  {
    avatar: 'W',
    name: '深夜吃瓜冠军',
    time: '28分钟前',
    content: '莫里秀这个瓜我追了一个月了，每天刷新等更新。51cg的追踪报道最及时，其他平台都是搬运你们的吧？',
    likes: 3547
  }
];